import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TransferconfirmPage } from './transferconfirm';

@NgModule({
  declarations: [
    TransferconfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(TransferconfirmPage),
  ],
})
export class TransferconfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/transferconfirm/transferconfirm.module.ts